/**
 * A 2px indeterminate bar for a quiet reload: the content below it stays,
 * this is the only sign that newer figures are on the way.
 */
export default function ProgressBar({ active }) {
  if (!active) return null;
  return (
    <div
      role="progressbar"
      aria-label="Refreshing"
      className="relative h-0.5 w-full overflow-hidden rounded bg-blue-100"
    >
      <div className="absolute inset-y-0 w-1/3 animate-pulse rounded bg-blue-500" />
    </div>
  );
}
